import React from "react";
import GenericRoutesList from "components/Routes/GenericRoutesList";
import { ROUTE_CONFIGS } from "config/routeConfigs";
import withConfirm from "components/dialogs/delete";

const CurrentRoutes = ({ confirm }) => {
  const config = ROUTE_CONFIGS.current;
  return (
    <GenericRoutesList
      routeType="current"
      columnsConfig={config.columns}
      columnsWithPDF={config.columnsWithPDF}
      mapPath={config.mapPath}
      features={config.features}
      confirm={confirm}
      selector={config.selector}
      paginationSelector={config.paginationSelector}
      loadAction={config.loadAction}
    />
  );
};

export default withConfirm(CurrentRoutes);
